import angular from 'angular';
import { getInvoiceStreamNames } from '@/shared/services/InvoiceStreamService';

angular.module('commonServices').factory('invoiceStreamNamesSvc', [
  '$q',
  function($q) {
    return {
      // $q.when wraps the native promise so resolution triggers a digest
      get: (relationId, forInvoice = false) =>
        $q.when(getInvoiceStreamNames(relationId, forInvoice)),
    };
  },
]);
